import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { RefundableFlightsComponent } from './refundable-flights.component';

@NgModule({ declarations: [RefundableFlightsComponent],
    exports: [RefundableFlightsComponent], imports: [CommonModule, ModalModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class RefundableFlightsModule {}
